<template>
  <Tag class="TagRemovable">
    <span class="label">
      {{ label }}
    </span>
    <Icon
      name="cross"
      @click="$emit('remove')" />
  </Tag>
</template>

<script>
export default {
  props: {
    label: String,
  },
}
</script>

<style lang="scss">
.TagRemovable {
  height: min-content;

  > .label {
    color: $white;
    line-height: 1.5rem;
  }

  > .Icon {
    cursor: pointer;
    line-height: 1.5rem;
    margin-left: 0.25rem;
  }
}
</style>
